import { gql } from "@grandvisionhq/graphql";
const productFragment = gql`
  fragment ProductFragment on Product {
    name
    slug
    variants {
      ... on Variant {
        sku
        prices {
          originalPrice {
            currencyCode
            amount
          }
          discountedPrice {
            price {
              currencyCode
              amount
            }
          }
        }
        media {
          images {
            url
            dimensions {
              w
              h
            }
            label
          }
        }
      }
    }
  }
`;
export {
  productFragment
};
//# sourceMappingURL=product.js.map
